import { AuthenticatedGuard } from "@/components/authenticated-guard";
import Header from "@/components/header.tsx";
import { AccountSetupCheck } from "@/components/registrant/account-setup-check";
import { EmailVerificationCheck } from "@/components/registrant/email-verification-check";
import { OperatorImpersonationGate } from "@/components/registrant/operator-impersonation-gate";
import { UserType } from "@/constants";
import { useLicenseChangeEvents } from "@/hooks/use-license-change-events";
import { getRegistrantLoginConnection } from "@/lib/registrant-login-connection";
import { useAuth0 } from "@auth0/auth0-react";
import { Outlet, createFileRoute } from "@tanstack/react-router";
import Auth0Provider from "../integrations/auth0/root-provider.tsx";

function RegistrantLayout() {
  const { user } = useAuth0();
  useLicenseChangeEvents();

  return (
    <div className="flex h-dvh flex-col overflow-hidden">
      <Header
        user={user || null}
        showRegistrantOperatorImpersonation
        showRegistrantHelp
        blogPath="/registrant/blog"
      />
      <main className="flex flex-1 min-h-0 w-full justify-center overflow-hidden p-4 md:p-6 max-w-[1600px] mx-auto bg-background">
        <AuthenticatedGuard
          allowedUserTypes={[UserType.REGISTRANT, UserType.OPERATOR]}
          loginConnection={getRegistrantLoginConnection()}
        >
          <OperatorImpersonationGate>
            <AccountSetupCheck>
              <EmailVerificationCheck>
                <div
                  data-slot="portal-page-scroll"
                  className="flex flex-1 min-h-0 w-full min-w-0 flex-col overflow-y-auto"
                >
                  <Outlet />
                </div>
              </EmailVerificationCheck>
            </AccountSetupCheck>
          </OperatorImpersonationGate>
        </AuthenticatedGuard>
      </main>
    </div>
  );
}

export const Route = createFileRoute("/registrant")({
  component: () => (
    <Auth0Provider
      audience={import.meta.env.VITE_AUTH0_REGISTRANT_AUDIENCE}
      clientId={import.meta.env.VITE_AUTH0_REGISTRANT_CLIENT_ID}
      callbackPath="/registrant/auth_callback"
    >
      <RegistrantLayout />
    </Auth0Provider>
  ),
});
